import { registerComponent } from '@gig/magic-common';
import CookiePopupNotificationComponent from './cookie-popup-notification.vue.js';

var CookiePopupNotification = registerComponent(CookiePopupNotificationComponent);

export { CookiePopupNotification };
